var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentTotlaAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#E0E2E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    stroke: "#F0F1F3",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 23C13.5 22.4477 13.9477 22 14.5 22H18.5C19.0523 22 19.5 22.4477 19.5 23C19.5 23.5523 19.0523 24 18.5 24H14.5C13.9477 24 13.5 23.5523 13.5 23Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 15C10.5 13.3431 11.8431 12 13.5 12H27.5C29.1569 12 30.5 13.3431 30.5 15V25C30.5 26.6569 29.1569 28 27.5 28H13.5C11.8431 28 10.5 26.6569 10.5 25V15ZM13.5 14H27.5C28.0523 14 28.5 14.4477 28.5 15V16H12.5V15C12.5 14.4477 12.9477 14 13.5 14ZM28.5 18V25C28.5 25.5523 28.0523 26 27.5 26H13.5C12.9477 26 12.5 25.5523 12.5 25V18H28.5Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentTotlaAmount);
export default __webpack_public_path__ + "static/media/payment-totla-amount.a56de020512e4b75fc08399be1baf97f.svg";
export { ForwardRef as ReactComponent };